import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import Selectsearch from "react-select"
import DatePicker from "react-datepicker"
import Select from 'react-select';
import moment from 'moment';
import IconButton from '@mui/material/IconButton';
import "react-datepicker/dist/react-datepicker.css";
import { NotificationManager } from 'react-notifications';

import {
    FormGroup,
    Label,

} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {
    allStudents,
    addTravelForm
} from 'Actions';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';


class AddItems extends React.Component {

    static propTypes = {
        classes: PropTypes.object,
        prev: 0,
    };

    UNSAFE_componentWillMount() {
        this.props.allStudents();

    }
    constructor(props) {

        super(props);
        this.state = {
            student: '',
            checkoutdate: '',
            checkindate: '',
            checkouttime: '',
            checkintime: '',
            seldate: new Date(),
            result: '',
            event: '',
            sepmore: 1,
            chkcount: 0,
            loader: false,
            othname: false,
            formValues: [{ reasonfortravel: "", numberofdays: "", placetravellingto: "" }],


        };

    }


    handleChange(i, e) {
        var totdays=this.state.result;
        let formValues = this.state.formValues;       
        formValues[i][e.target.name] = e.target.value;
       
        
        if(e.target.name=='numberofdays'){

            var exptot=0;

            formValues.forEach(frmval => {
                var numberday=frmval.numberofdays;
                exptot=parseFloat(exptot)+parseFloat(numberday);
            });
            
            if(totdays>=exptot){            
                this.setState({ chkcount:exptot });
                this.setState({ formValues });
            }else{            
                formValues[i][e.target.name] = '';
                this.setState({ formValues });
            }          

        }else{
            this.setState({ formValues });
        }
        
        
    }


    addFormFields() {

        var totdays = this.state.result;
        let formValues = this.state.formValues;

        var exptot = 0;
        formValues.forEach(frmval => {
            var numberday = frmval.numberofdays;
            exptot = parseFloat(exptot) + parseFloat(numberday);
        });

        if (totdays > exptot) {

            var chktotal = this.state.sepmore;
            var totalsep = chktotal + 1;
            this.setState(({
                sepmore: totalsep,
                formValues: [...this.state.formValues, { reasonfortravel: "", numberofdays: "", placetravellingto: "" }]
            }))
        }

    }

    removeFormFields(i) {
        let formValues = this.state.formValues;
        var chktotal = this.state.sepmore;
        var totalsep = chktotal - 1;
        formValues.splice(i, 1);
        this.setState({ formValues, sepmore: totalsep });
    }




    addHandleSubmit(event) {
        event.preventDefault();
        var sepmore = this.state.sepmore;
        var leavecnt = this.state.result;
        let formValues = this.state.formValues;
        var exptot = 0;
        formValues.forEach(frmval => {
            var numberday = frmval.numberofdays;
            exptot = parseFloat(exptot) + parseFloat(numberday);
        });

        if (leavecnt > exptot) {
            NotificationManager.error('Please enter correct days in seprations');
        } else {
            this.setState({ loader: true });
            this.props.addTravelForm(event, sepmore, leavecnt).then((data) => {
                this.setState({ loader: false });
                if (data.status == 1) {
                    document.getElementById("addform").reset();
                    setTimeout(this.props.onClick, 5000);
                }
            });
        }
    }


    selectdateo = (date) => {

        this.setState({ checkoutdate: date });
        this.daysDifference(date, 1);

    }

    selectdatei = (date) => {

        this.setState({ checkindate: date });
        this.daysDifference(date, 2);

    }

    selecttimeo = (event) => {
        var time = event.target.value;
        this.setState({ checkouttime: time });
        this.daysDifference(time, 3);


    }

    selecttimei = (event) => {
        var time = event.target.value;
        this.setState({ checkintime: time });
        this.daysDifference(time, 4);
    }


    daysDifference(aeldate, pst) {


        if (pst == 1) {
            var checkoutdate = aeldate;
            var checkindate = this.state.checkindate;
            var checkouttime = this.state.checkouttime;
            var checkintime = this.state.checkintime;
        } else if (pst == 2) {
            var checkoutdate = this.state.checkoutdate;
            var checkindate = aeldate;
            var checkouttime = this.state.checkouttime;
            var checkintime = this.state.checkintime;

        } else if (pst == 3) {
            var checkoutdate = this.state.checkoutdate;
            var checkindate = this.state.checkindate;
            var checkouttime = aeldate;
            var checkintime = this.state.checkintime;
        } else {
            var checkoutdate = this.state.checkoutdate;
            var checkindate = this.state.checkindate;
            var checkouttime = this.state.checkouttime;
            var checkintime = aeldate;
        }

        if (checkoutdate != "" && checkouttime != "" && checkindate != "" && checkintime != "") {

            var firstDate = moment(new Date(checkoutdate)).format('YYYY-MM-DD') + ' 00:01';
            var secondDate = moment(new Date(checkindate)).format('YYYY-MM-DD') + ' 00:01';
            var firstTime = moment(new Date(checkoutdate)).format('DD MMMM YYYY') + ' ' + checkouttime;
            var secondTime = moment(new Date(checkindate)).format('DD MMMM YYYY') + ' ' + checkintime;

            var days = this.betweendays(firstDate, secondDate, firstTime, secondTime);

            this.setState({ result: days });

        }
    }

    betweendays(firstDate, secondDate, firstTime, secondTime) {

        var start = new Date(firstDate);
        var end = new Date(secondDate);
        var diff = new Date(end - start);
        var days = diff / 1000 / 60 / 60 / 24 - 1;

        var ftoday = new Date(firstTime);
        var frstcurHr = ftoday.getHours();
        if (frstcurHr >= 0 && frstcurHr < 7) {
            var fminus = 1;
        } else if (frstcurHr >= 7 && frstcurHr < 11) {
            var fminus = '.5';
        } else if (frstcurHr >= 11 && frstcurHr < 24) {
            var fminus = 0;
        }

        var stoday = new Date(secondTime)
        var sedcurHr = stoday.getHours();
        if (sedcurHr >= 0 && sedcurHr < 14) {
            var sminus = 0;
        } else if (sedcurHr >= 14 && sedcurHr < 17) {
            var sminus = '.5';
        } else if (sedcurHr >= 17 && sedcurHr < 24) {
            var sminus = 1;
        }

        var totaldays = parseInt(days) + parseFloat(fminus) + parseFloat(sminus);

        if (Math.sign(totaldays) == '-1') {
            totaldays = 0;
        }

        return totaldays;


    }


    handletravelwith(selectedOption) {
        const selval = selectedOption.value;

        if (selval === 'Others') {
            this.setState({ othname: true });
        } else {
            this.setState({ othname: false });
        }
    }




    render() {

        const { studentlists, ssteamlists, loading } = this.props;


        const allstudent = studentlists.map((stdval) => {
            return {
                label: stdval.student || '',
                value: stdval.uudID

            }
        });

        const styles = {
            buttonProgress: {
                color: "blue",
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginTop: -15,
                marginLeft: -15,
            },
            wrapper: {
                position: 'relative',
            },
        };


        return (
            <div>
                <div className="col-lg-12">
                    <form autoComplete="off" id="addform" onSubmit={(e) => this.addHandleSubmit(e)}>
                        <div className="col-sm-12 col-lg-8" style={{ margin: "0 auto" }}>
                            <RctCollapsibleCard heading="Create Form">
                                <div className="row float-right">
                                    <button type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} >Back</button>
                                </div>
                                <div className="row">

                                    <div className="col-sm-12 col-lg-8">
                                        <FormGroup>
                                            <Label for="Select">Name *</Label>
                                            <Selectsearch className="form-control" id="student" name="student" options={allstudent} rules={{ required: 'Please select an student' }} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.setState({ student: evt.value })} required />
                                        </FormGroup>
                                    </div>

                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <FormGroup>
                                            <Label for="Email-3">Check-Out Date *</Label>
                                            <DatePicker className="form-control" id="checkoutdate" name="checkoutdate" autoComplete="off" required
                                                selected={this.state.checkoutdate}
                                                onChange={this.selectdateo}
                                                dateFormat='yyyy-MM-dd'
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                            />
                                        </FormGroup>
                                    </div>

                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <FormGroup>
                                            <Label for="Email-2">Check-Out Time *</Label>
                                            <input type="time" className="form-control" id="checkouttime" name="checkouttime"
                                                selected={this.state.checkouttime}
                                                onChange={this.selecttimeo}
                                            ></input>
                                        </FormGroup>
                                    </div>


                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <FormGroup>
                                            <Label for="Email-3">Check-In Date * (tentative)</Label>
                                            <DatePicker className="form-control" id="checkindate" name="checkindate" autoComplete="off" required
                                                selected={this.state.checkindate}
                                                onChange={this.selectdatei}
                                                minDate={this.state.checkoutdate}
                                                dateFormat='yyyy-MM-dd '
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                            />
                                        </FormGroup>
                                    </div>

                                    <div className="col-sm-12 col-lg-6 col-xl-6">
                                        <FormGroup>
                                            <Label for="Email-2">Check-In Time *</Label>
                                            <input type="time" className="form-control" id="checkintime" name="checkintime"
                                                selected={this.state.checkintime}
                                                onChange={this.selecttimei}
                                            ></input>

                                        </FormGroup>
                                    </div>

                                    <div className="col-sm-12 col-lg-8 col-xl-8">

                                        <FormGroup>
                                            <Label for="Email-2">Days off from training :   </Label>
                                            {this.state.result} days
                                        </FormGroup>

                                    </div>
                                    <div className="col-sm-12 col-lg-4 col-xl-4">
                                        <div className="dd">
                                            <button className="mr-3 mb-3 btn btn-outline-primary float-right" type="button" onClick={() => this.addFormFields()}> <i class="zmdi zmdi-plus-circle-o"></i> add more</button>
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-lg-12 col-xl-12" style={{ border: "1px solid #ccc", padding: "10px", marginBottom: "20px" }}>


                                        {this.state.formValues.map((element, index) => (

                                            <div className="row" key={index}>
                                                <div className="col-lg-4">                                               
                                                    <FormGroup>
                                                        <Label for="Select">Reason for Travel *</Label>
                                                        <select  name="reasonfortravel" id={"sepopt_"+index} required  className="form-control form-control-alternative" 
                                                    value={element.reasonfortravel || ""} onChange={e => this.handleChange(index, e)}>
                                                        <option value=""> </option>
                                                        <option value="Tournament">Tournament</option>
                                                        <option value="Medical">Medical</option>
                                                        <option value="Personal">Personal</option> 
                                                        <option value="Clubfitting">Club Fitting</option>  
                                                        <option value="Academics">Academics</option>                                               
                                                    </select>
                                                    </FormGroup>
                                                </div>
                                                <div className="col-lg-3">
                                                    <FormGroup>
                                                        <Label for="Select">Number of Days *</Label>
                                                        <input type="text" name="numberofdays" id={"sepday_" + index} className="form-control form-control-alternative" required
                                                            value={element.numberofdays || ""} onChange={e => this.handleChange(index, e)} />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-lg-4">
                                                    <FormGroup>
                                                        <Label for="Select">Place travelling to *</Label>
                                                        <input type="text" name="placetravellingto" id={"septravel_" + index} className="form-control form-control-alternative" required
                                                            value={element.placetravellingto || ""} onChange={e => this.handleChange(index, e)} />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-lg-1">
                                                    {
                                                        index ?
                                                            <IconButton style={{ width: "10px", height: "10px", marginTop: "30px" }} className="text-danger" aria-label="Remove" onClick={() => this.removeFormFields(index)}  > <DeleteOutlineOutlinedIcon/></IconButton>
                                                            : null
                                                    }
                                                </div>
                                            </div>
                                        ))}

                                    </div>

                                    <div className="col-sm-12 col-lg-6">
                                    <Label for="Select">Whom are you travelling with *</Label>
                                        <FormGroup>
                                            <Label for="Select">Whom are you travelling with *</Label>
                                            <Selectsearch
                                                options={[
                                                    { value: '', label: '' },
                                                    { value: 'Alone', label: 'Alone' },
                                                    { value: 'Parents', label: 'Parents' },
                                                    { value: 'Others', label: 'Others' },
                                                ]}
                                                value={this.state.travelwith}
                                                onChange={selectedOption => this.handletravelwith(selectedOption)}
                                                name="travelwith"
                                                id="travelwith"
                                                required
                                            />

                                        </FormGroup>
                                    </div>
                                    {this.state.othname &&
                                        <div className="col-sm-12 col-lg-6">
                                            <FormGroup>
                                                <Label for="Select">Person Name *</Label>
                                                <input type="text" name="personname" id="personname" className="form-control form-control-alternative" required />
                                            </FormGroup>
                                        </div>
                                    }
                                    <div className="col-sm-12 col-lg-6">
                                    <Label for="Select">Mode of transport from campus *</Label>
                                        <FormGroup>
                                            <Label for="Select">Mode of transport from campus *</Label>
                                            <Select
                                                name="transport"
                                                id="transport"
                                                required
                                                options={[
                                                    { label: '', value: '' },
                                                    { label: 'Cab Arranged by TSG', value: 'Cab Arranged by TSG' },
                                                    { label: 'Personal Car', value: 'Personal Car' },
                                                    { label: 'Another TSG Students Vehicle', value: 'Another TSG Students Vehicle' },
                                                    { label: 'TSG Staff Car', value: 'TSG Staff Car' }
                                                ]}
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-sm-12 col-lg-12">
                                        <div className="form-group" style={styles.wrapper}>
                                            <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" disabled={this.state.loader}>Submit</button>
                                            {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}
                                        </div>
                                    </div>
                                </div>
                            </RctCollapsibleCard>
                        </div>
                    </form>
                </div>
            </div>

        )

    }

}

const mapStateToProps = ({ mostlyused, ssteam }) => {
    const { studentlists, loading } = mostlyused;
    const { ssteamlists } = ssteam;
    return { studentlists, ssteamlists, loading };

}


export default connect(mapStateToProps, {
    allStudents,
    addTravelForm,


})(AddItems);
